import { useAtom } from "jotai";
import { InitialAtom, StartDateAtom, YearsAtom } from "./atoms";
import { ResultChart } from "./resultChart";
import * as React from "react";
import clsx from "clsx";

export function Graph() {
  const [startDate] = useAtom(StartDateAtom);
  const [years] = useAtom(YearsAtom);
  const [initial] = useAtom(InitialAtom);
  return (
    <div className="atc-result-content__graph-container">
      <div className={clsx("atc-graph", { "years-creater-than-8": years > 8 })}>
        <ResultChart years={years} initial={initial} startDate={startDate} />
      </div>
    </div>
  );
}
